import usePaymentPlans from "./usePaymentPlans";

export default function useMinPlanPrice() {
    const { plans } = usePaymentPlans();
    const prices = plans && plans.map((plan) => {
        let months = 1;
        if (plan.subscriptionType === 'MONTHLY') {
            months = 1;
        } else if (plan.subscriptionType === 'QUARTERLY') {
            months = 3;
        } else if (plan.subscriptionType === 'HALFYEARLY') {
            months = 6;
        } else if (plan.subscriptionType === 'YEARLY') {
            months = 12;
        }
        return Math.floor(plan.price / months);
    });
    const minPrice = prices && prices.length ? Math.min(...prices) : 0;
    return minPrice;
}
